"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegisterChildData = exports.ChildDataRegistryProvider = exports.useChildRegistry = exports.childDataApi = void 0;
const compound_components_1 = require("@clds/compound-components");
exports.childDataApi = (0, compound_components_1.createChildDataApi)('dropdown menu items');
exports.useChildRegistry = exports.childDataApi.useChildRegistry;
exports.ChildDataRegistryProvider = exports.childDataApi.ChildDataRegistryProvider;
exports.useRegisterChildData = exports.childDataApi.useRegisterChildData;
//# sourceMappingURL=childData.js.map